module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14q0Iae/tc-custom/9780802148254.jpg?1701542632316",
      "alt": "This image is the cover for the book Secret Service, The Kate Henderson Thrillers"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Secret Service, The Kate Henderson Thrillers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An MI6 officer must find a traitor hiding within the highest ranks of government in a new thriller with “resonant echoes of le Carré” ("), _c('i', [_vm._v("Booklist")]), _vm._v(", starred review).")]), _c('br'), _c('br'), _vm._v(" Senior MI6 officer Kate Henderson is in possession of the political equivalent of a nuclear bomb. She heads up the Russia Desk of the Secret Intelligence Service, and one of her undercover operations has revealed some alarming evidence that a senior UK politician is a high-level Russian informer."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Determined to find the identity of the traitor, Kate must risk everything to get to the truth. Until a young woman is brutally murdered as a consequence, which puts Kate and her team under the spotlight. With blood on her hands, her reputation to uphold, her family hanging by a thread, and an election looming, Kate is quickly running out of options—and out of time . . ."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" From the author of "), _c('i', [_vm._v("Shadow Dancer")]), _vm._v(" and "), _c('i', [_vm._v("The White Russian")]), _vm._v(", who has been a finalist for multiple Crime Writers Association awards, this is a tense, timely novel of secrets, betrayals, and spycraft.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tom Bradby\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Tom Bradby is British novelist, screenwriter, and journalist who has written six previous novels that have been bestsellers in the UK.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grove Atlantic\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0